import { Component, EventEmitter, HostListener, Input, OnInit, Output, ViewEncapsulation } from '@angular/core';
import { Router } from '@angular/router';
import { AlertsService } from '../../services/alerts.service';
import { DomSanitizer } from '@angular/platform-browser';

@Component({
  selector: 'app-sidebar',
  templateUrl: './sidebar.component.html',
  styleUrls: ['./sidebar.component.scss'],
  standalone: false,
  encapsulation: ViewEncapsulation.None
})
export class SidebarComponent implements OnInit {
  sidebarBgImage = this.sanitizeSvg(`<svg xmlns="http://www.w3.org/2000/svg" width="230.949" height="258.594" viewBox="0 0 230.949 258.594">
              <g id="Group_616" data-name="Group 616" transform="translate(-20 -740.768)" opacity="0.751">
                <path id="Path_427" data-name="Path 427" d="M100.36,268.8l48.68,28.074,41.428-23.916s21.749-10.176,
                21.749-41.586v-86.3l-48.68-29.112v79.02s4.928,33.374-22.78,49.908-40.4,23.916-40.4,23.916Z" 
                transform="translate(-80.36 624.808)" fill="#E3EDFE" fill-rule="evenodd"/>
                <path id="Path_428" data-name="Path 428" d="M200.32,353.248l47.642,29.112s36.278-20.594,38.321-21.834,
                26.213-11.24,25.893-46.794,0-33.27,0-33.27L264.535,251.35v36.4a50.287,50.287,0,0,1-25.893,43.667c-24.79,
                14.119-38.321,21.834-38.321,21.834Z" transform="translate(-115.079 578.304)" fill="#E3EDFE" 
                fill-rule="evenodd"/>
                <path id="Path_429" data-name="Path 429" d="M301.87,449.252l47.642,29.112,51.78-32.231L353.656,417.02,
                301.87,449.252Z" transform="translate(-150.343 520.998)" fill="#E3EDFE" fill-rule="evenodd"/>
              </g>
            </svg>
        `);

  isSidebarCollapsed = false;
  isMobileView = false;
  @Input() customClass: string = '';
  @Input() isMobSidebarVisible: boolean = false;// for mobile

  @Output() sidebarToggled = new EventEmitter<boolean>();
  @Output() mobileSidebarToggled = new EventEmitter<boolean>();

  @HostListener('window:resize')
  onResize() {
    this.checkViewport();
  }
  checkViewport() {
    this.isMobileView = window.innerWidth <= 1024;
  }

  toggleSidebar() {
    if (this.isMobileView) {
      // Mobile behavior: hide/show sidebar
      this.mobileSidebarToggled.emit(true);

    } else {
      this.isSidebarCollapsed = !this.isSidebarCollapsed;
      this.sidebarToggled.emit(this.isSidebarCollapsed);
    }
  }

  closeSidebarOnClick() {
    if (this.isMobileView) {
      this.toggleSidebar();
    }
  }

  constructor(
    private router: Router,
    private alertService: AlertsService,
    private sanitizer: DomSanitizer
  ) { }


  sideBarMenus = [
    {
      title: 'Dashboard',
      linkIcon: this.sanitizeSvg(`<svg xmlns="http://www.w3.org/2000/svg" width="16.085" height="16.621" viewBox="0 0 16.085 16.621">
            <g id="_7738936_home_house_dashboard_home_page_apps_icon" data-name="7738936_home_house_dashboard_home page_apps_icon" transform="translate(-2 -1)">
              <path id="Path_199" data-name="Path 199" d="M26.289,46.681a.536.536,0,1,0,1.072,0v-.268A2.416,2.416,0,0,0,24.949,44h-.536A2.416,2.416,0,0,0,22,46.413v.268a.536.536,0,1,0,1.072,0v-.268a1.342,1.342,0,0,1,1.34-1.34h.536a1.342,1.342,0,0,1,1.34,1.34Z" transform="translate(-14.638 -31.473)" fill="#121111"/>
              <path id="Path_200" data-name="Path 200" d="M17.889,7.288,10.383,1.122a.536.536,0,0,0-.681,0L2.2,7.288A.536.536,0,0,0,2,7.7V9.847a.536.536,0,0,0,.536.536h.8v6.7a.536.536,0,0,0,.536.536H7.9a.536.536,0,0,0,0-1.072H4.413v-6.7a.536.536,0,0,0-.536-.536h-.8V7.955l6.97-5.725,6.97,5.725V9.31h-.8a.536.536,0,0,0-.536.536v6.7H12.187a.536.536,0,1,0,0,1.072h4.021a.536.536,0,0,0,.536-.536v-6.7h.8a.536.536,0,0,0,.536-.536V7.7A.536.536,0,0,0,17.889,7.288Z" fill="#121111"/>
            </g>
          </svg>
        `),
      link: '/dashboard'
    },
    {
      title: 'Transactions',
      linkIcon: this.sanitizeSvg(`<svg xmlns="http://www.w3.org/2000/svg" width="15.206" height="14.621" viewBox="0 0 15.206 14.621">
            <g id="Transaction" transform="translate(-6 -7)">
              <path id="Path_227" data-name="Path 227" d="M19.452,7H7.755A1.755,1.755,0,0,0,6,8.755V19.867a1.755,1.755,0,0,0,1.755,1.755h11.7a1.755,1.755,0,0,0,1.755-1.755V8.755A1.755,1.755,0,0,0,19.452,7Zm.585,12.867a.585.585,0,0,1-.585.585H7.755a.585.585,0,0,1-.585-.585V8.755a.585.585,0,0,1,.585-.585h11.7a.585.585,0,0,1,.585.585Z" transform="translate(0 0)" fill="#231f20"/>
              <path id="Path_228" data-name="Path 228" d="M24.48,22a.585.585,0,1,0,0-1.17H18l.754-.757a.585.585,0,0,0-.825-.825L16.172,21a.583.583,0,0,0,.412,1Z" transform="translate(-7.075 -8.568)" fill="#231f20"/>
              <path id="Path_229" data-name="Path 229" d="M26.48,36h-7.9a.585.585,0,0,0,0,1.17h6.483l-.754.757a.585.585,0,1,0,.825.825L26.893,37a.583.583,0,0,0-.412-1Z" transform="translate(-8.491 -20.52)" fill="#231f20"/>
            </g>
          </svg>
        `),
      link: '/transactions'
    },
    // {
    //   title: 'Insights',
    //   icon: this.sanitizeSvg(`<svg xmlns="http://www.w3.org/2000/svg" width="14.245" height="14.238" viewBox="0 0 14.245 14.238">
    //         <g id="Insights" transform="translate(-1.369 -1.4)">
    //           <path id="Path_230" data-name="Path 230" d="M14.5,11.328a6.507,6.507,0,1,1-8.6-8.5" transform="translate(0 -0.29)" fill="none" stroke="#121111" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.2"/>
    //           <path id="Path_231" data-name="Path 231" d="M18.507,8.507A6.507,6.507,0,0,0,12,2V8.507Z" transform="translate(-3.493 0)" fill="none" stroke="#121111" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.2"/>
    //         </g>
    //       </svg>
    //     `),
    //   link: '/insights'
    // },
    {
      title: 'Credit Score',
      linkIcon: this.sanitizeSvg(`<svg xmlns="http://www.w3.org/2000/svg" width="20.095" height="10.61" viewBox="0 0 20.095 10.61">
              <g id="_x32_0_x5F_Credit_x5F_Score" transform="translate(-6.125 -23.125)">
                <path id="Path_232" data-name="Path 232" d="M26.22,33.173a.562.562,0,0,1-.562.562h-2.74a.562.562,0,1,1,0-1.124h2.161a8.924,8.924,0,0,0-17.812,0H9.427a.562.562,0,1,1,0,1.124H6.687a.562.562,0,0,1-.562-.562,10.048,10.048,0,0,1,20.1,0Zm-9.486-6.183V25.865a.562.562,0,0,0-1.124,0v1.124a.562.562,0,1,0,1.124,0Zm1.616,2.34a.562.562,0,0,0-.768.206l-1.454,2.517a1.124,1.124,0,0,0-1.081,1.12.562.562,0,0,0,.562.562h1.124a.562.562,0,0,0,.562-.562,1.115,1.115,0,0,0-.173-.593L18.557,30.1A.561.561,0,0,0,18.351,29.33Zm1.757-2.972a.562.562,0,0,0-.768.206l-.562.974a.562.562,0,1,0,.974.562l.562-.974A.561.561,0,0,0,20.107,26.357Zm2.881,2.881a.562.562,0,0,0-.768-.206l-.974.562a.562.562,0,1,0,.562.974l.974-.562A.562.562,0,0,0,22.988,29.238Zm-9.982-2.675a.562.562,0,0,0-.974.562l.562.974a.562.562,0,1,0,.974-.562ZM11.1,29.594l-.974-.562a.562.562,0,0,0-.562.974l.974.562a.562.562,0,1,0,.562-.974Z" fill="#121111"/>
              </g>
            </svg>
          `),
      link: '/credit-score'
    },
    {
      title: 'Offers',
      linkIcon: this.sanitizeSvg(`<svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 18 18">
                <g id="Offers" transform="translate(-0.04 -0.04)">
                  <rect id="Rectangle_212" data-name="Rectangle 212" width="18" height="18" transform="translate(0.04 0.04)" fill="none"/>
                  <rect id="Rectangle_213" data-name="Rectangle 213" width="14" height="3" rx="1.5" transform="translate(2.04 6.04)" fill="none" stroke="#000" stroke-linecap="round" stroke-linejoin="round" stroke-width="1"/>
                  <path id="Path_233" data-name="Path 233" d="M59.63,128v5.234a.582.582,0,0,1-.582.581H48.582a.581.581,0,0,1-.582-.581V128" transform="translate(-44.775 -118.96)" fill="none" stroke="#000" stroke-linecap="round" stroke-linejoin="round" stroke-width="1"/>
                  <line id="Line_69" data-name="Line 69" y2="9" transform="translate(9.04 6.04)" fill="none" stroke="#000" stroke-linecap="round" stroke-linejoin="round" stroke-width="1"/>
                  <path id="Path_234" data-name="Path 234" d="M131.293,30.642c-.829.821-3.293.821-3.293.821s0-2.464.821-3.293a1.748,1.748,0,0,1,2.471,2.471Z" transform="translate(-118.96 -25.912)" fill="none" stroke="#000" stroke-linecap="round" stroke-linejoin="round" stroke-width="1"/>
                  <path id="Path_235" data-name="Path 235" d="M76.17,30.642c.829.821,3.293.821,3.293.821s0-2.464-.821-3.293a1.748,1.748,0,0,0-2.471,2.471Z" transform="translate(-70.423 -25.912)" fill="none" stroke="#000" stroke-linecap="round" stroke-linejoin="round" stroke-width="1"/>
                </g>
              </svg>
          `),
      link: '/offers',
      specialFlag: true
    },
    {
      title: 'Settings',
      linkIcon: this.sanitizeSvg(`<svg xmlns="http://www.w3.org/2000/svg" width="15.143" height="15.143" viewBox="0 0 15.143 15.143">
                <g id="Settings" transform="translate(-2 -2)">
                  <path id="Path_236" data-name="Path 236" d="M17.143,9.571a2.167,2.167,0,0,0-1.788-2.131l-.188-.452a2.166,2.166,0,0,0-.242-2.771,2.213,2.213,0,0,0-2.772-.242L11.7,3.788a2.163,2.163,0,0,0-4.261,0l-.452.187a2.164,2.164,0,0,0-3.4,1.772,2.145,2.145,0,0,0,.392,1.242l-.187.451A2.167,2.167,0,0,0,2,9.571H2A2.167,2.167,0,0,0,3.788,11.7l.187.451a2.167,2.167,0,0,0,.242,2.772,2.214,2.214,0,0,0,2.772.242l.452.187a2.163,2.163,0,0,0,4.261,0l.452-.188a2.164,2.164,0,0,0,3.014-3.013l.187-.451a2.166,2.166,0,0,0,1.788-2.131Zm-2.163,1.083a.541.541,0,0,0-.5.334l-.437,1.053a.541.541,0,0,0,.117.589,1.082,1.082,0,0,1-1.53,1.53.541.541,0,0,0-.589-.117l-1.054.437a.541.541,0,0,0-.334.5,1.082,1.082,0,1,1-2.163,0,.541.541,0,0,0-.334-.5L7.1,14.043a.541.541,0,0,0-.589.117,1.107,1.107,0,0,1-1.529,0,1.083,1.083,0,0,1,0-1.53.541.541,0,0,0,.117-.589l-.437-1.053a.541.541,0,0,0-.5-.334A1.083,1.083,0,0,1,3.082,9.572h0A1.083,1.083,0,0,1,4.163,8.49a.542.542,0,0,0,.5-.334L5.1,7.1a.541.541,0,0,0-.117-.589,1.082,1.082,0,0,1,1.53-1.53A.543.543,0,0,0,7.1,5.1l1.054-.437a.542.542,0,0,0,.334-.5,1.082,1.082,0,1,1,2.163,0,.542.542,0,0,0,.334.5l1.055.437a.541.541,0,0,0,.589-.117,1.107,1.107,0,0,1,1.529,0,1.084,1.084,0,0,1,0,1.53.541.541,0,0,0-.117.589l.437,1.055a.541.541,0,0,0,.5.333,1.083,1.083,0,0,1,1.082,1.082h0A1.083,1.083,0,0,1,14.979,10.654Z" fill="#121111"/>
                  <path id="Path_237" data-name="Path 237" d="M13.7,11a2.7,2.7,0,0,0,0,5.408.541.541,0,0,0,0-1.082,1.62,1.62,0,1,1,1.362-.74.541.541,0,1,0,.907.588A2.705,2.705,0,0,0,13.7,11Z" transform="translate(-4.133 -4.133)" fill="#121111"/>
                </g>
              </svg>
          `),
      link: '/settings'
    },
    // {
    //   title: 'Logout',
    //   icon: 'assets/images/sidebar/logout.svg',
    //   action: () => this.logout()
    // }
  ];
  sanitizeSvg(svg: string) {
    return this.sanitizer.bypassSecurityTrustHtml(svg);
  }
  ngOnInit() {
    this.checkViewport();
  }


  // Logout function
  async logout() {
    console.log('User logged out');
    const confirmed = await this.alertService.presentAlertConfirm({
      message: 'Are you sure you want to log out?'
    });

    if (confirmed) {
      // Implement logout logic here
      localStorage.clear();
      this.router.navigate(['/login']);
    }
  }
}
